<template>
  <div class="empty">
    <div class="list-header">
      <div class="header-bg">
        <div class="header-top">
          <van-icon class="el-icon-arrow-left" @click="backHome" name="arrow-left" />
          <span class="title">订单查询</span>
        </div>
        <div class="search">
          <div class="search-input">
            <van-icon class="el-icon-search" name="search" color="#b2b2b2" />
            <input @input="changeNum" v-model="orderText" type="text" placeholder="请输入订单号" />
            <van-icon v-if="orderText" class="el-icon-error" @click="clear" name="clear" color="#b2b2b2" />
          </div>
          <span class="search-btn" @click="search">查询</span>
        </div>
        <p class="name"><van-icon class="wap-home" name="wap-home" />先锋团</p>
      </div>
    </div>
    <div class="empty-img">
      <img :src="require('../assets/images/empty-img.png')" alt=" ">
      <p>暂无订单</p>
    </div>
    <div class="tips">
      <p class="system-name">查无此订单，需取消重拍</p>
      <p>常见原因:</p>
      <p>1.没有从团购链接下单?请删除购物车从群公告链接重新拍。</p>
      <p>2.使用了推广优惠券?比如几毛钱的小红包，取消重试。</p>
    </div>
  </div>
</template>

<script>
import { checkInt } from '../utils/common'

export default {
  name: 'EmptyPage',
  components: {},
  props: {
    order: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      orderText: ''
    }
  },
  created(){
    this.orderText = this.order;
  },
  methods:{
    changeNum(){
      this.orderText = this.orderText ? checkInt(this.orderText) : null;
    },
    search(){
      this.$emit('search', this.orderText);
    },
    backHome(){
      this.$emit('backHome', 1);
    },
    clear(){
      this.orderText = null;
    }
  }
}
</script>

<style scoped>
.empty {
  height: 100%;
  background: #f8f8f8;
  overflow-x: hidden;
  overflow-y: scroll;
}
.list-header {
  height: 8.5rem;
  background: linear-gradient(180deg, #e93e37, #f3705e);
  border-radius: 0 0 1rem 1rem;
  position: relative;
}
.header-bg {
  background: url("../assets/images/bg.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}
.header-top {
  display: grid;
  grid-template-columns: 2rem 1fr 2rem;
  align-items: center;
  padding: 1rem 0.5rem 0;
}
.title {
  text-align: center;
  font-size: 1.2rem;
  font-weight: bold;
  background-image: linear-gradient(180deg, #f6fff9 0%, #ffe7b6 100%);
  -webkit-background-clip: text;
  color: transparent;
}
.el-icon-arrow-left {
  font-size: 1.2rem;
  color: #ffffff;
}
.search {
  width: 100%;
  padding: 0.4rem 0.8rem;
  display: flex;
  align-items: center;
}
.search-input {
  flex: 1;
  height: 1.8rem;
  position: relative;
}
.search-input input {
  outline: none;
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 1.8rem;
  padding: 0 1.8rem;
  font-size: 0.7rem;
  color: #333333;
}
.el-icon-search {
  position: absolute;
  font-size: 0.8rem;
  left: 0.6rem;
  top: 0.5rem;
  color: #b2b2b2;
}
.el-icon-error {
  position: absolute;
  font-size: 0.8rem;
  top: 0.5rem;
  right: 0.5rem;
  color: #b2b2b2;
}
.search-btn {
  width: 2.5rem;
  height: 1.6rem;
  background-color: #ffffff;
  border-radius: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000000;
  font-size: 0.7rem;
  font-weight: bold;
  margin-left: 0.5rem;
}
.name {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: PingFang SC;
  font-weight: bold;
  font-size: 1rem;
  background-image: linear-gradient(180deg, #f6fff9 0%, #ffe7b6 100%);
  -webkit-background-clip: text;
  color: transparent;
}
.wap-home {
  font-size: 1.2rem;
  background-image: linear-gradient(180deg, #f6fff9 0%, #ffe7b6 100%);
  -webkit-background-clip: text;
  color: transparent;
  margin-right: 0.2rem;
}
.empty-img {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 1rem;
}
.empty-img img {
  width: 5rem;
  height: 5rem;
}
.empty-img p {
  color: #666666;
  font-size: 0.7rem;
  padding-bottom: 1rem;
}
.tips {
  border: 0.05rem double #e8e2e3;
  padding: 2rem 0.5rem 0.5rem;
  border-radius: 1rem;
  margin: 0 0.8rem 1.5rem;
  background: #fef5f6;
  position: relative;
}
.tips p {
  color: #666666;
  font-size: 0.7rem;
  margin-top: 0.5rem;
}
.system-name {
  width: 9rem;
  height: 2rem;
  position: absolute;
  top: -0.05rem;
  left: -0.05rem;
  background: linear-gradient(90deg, #f6584a, #fe6647);
  margin-top: 0 !important;
  border-radius: 1rem 0.25rem 1.5rem 0;
  color: #ffffff !important;
  font-weight: bold;
  font-size: 0.75rem !important;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
